var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stream-barcode-reader',{on:{"decode":_vm.onDecode,"loaded":_vm.onLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }